var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container-term"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.term.content)}}),_c('div',{staticClass:"version"},[_vm._v("Version : "+_vm._s(_vm.term.version)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }